import mixpanel from 'mixpanel-browser';
import { AuthState, MeetingData } from '../../shared/types/types';
import { MIXPANEL_TOKEN } from '../constants';

const initializeMixpanel = () => {
  mixpanel.init(MIXPANEL_TOKEN);
};

export default initializeMixpanel;

export const setMixpanelUserAndLogAppStart = (authState: AuthState) => {
  mixpanel.identify(authState.userId);
  mixpanel.people.set({
    email: authState.email,
    firstName: authState.firstName,
    lastName: authState.lastName,
    fullName: `${authState.firstName} ${authState.lastName}`,
    $name: `${authState.firstName} ${authState.lastName}`,
    $email: authState.email,
  });
};

export const setMixpanelMeetingGroup = (meetingData: MeetingData) => {
  mixpanel.get_group(
    'meeting_id',
    meetingData.meetingId,
  ).set({
    $title: meetingData.data.title,
  });
};

export const setMixpanelUserMeetingGroup = (meetingData: MeetingData) => {
  mixpanel.set_group('meeting_id', meetingData.meetingId);
};

export const setMixpanelUserProperty = (properties: any) => {
  mixpanel.people.set(properties);
};

export const setMixpanelUserAlias = (userId: string) => {
  mixpanel.alias(userId);
};
